var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"background-color":"#fff"},attrs:{"id":_vm.id,"src":_vm.iframeSrc,"frameborder":"0","height":_vm.height,"scrolling":"auto","width":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }